import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useAddTagsReview() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.createDocumentTagsReviewDocumentsKeyTagsReviewsPostMutation(),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
      queryClient.removeQueries(
        apiClient.getDocumentTagsDocumentsKeyTagsGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: {
            key: variables.path.key,
          },
        }),
      )
    },
  })
}
